import { styled, flexColumn, flexRow, Colors, borderRadius } from '@unfold/theme';
export const Wrapper = styled.div`
  ${flexRow}
  flex-wrap: wrap;
  width: 100%;
  padding: 0;
`;

export const Section = styled.section`
  width: 340px;
  padding: 30px;
`;

/**
 * Settings -- Left Column
 */
export const Settings = styled(Section)`
  ${flexColumn}
  flex-basis: 100%;
  flex: 1;
`;

export const StorySettingsContainer = styled.div`
  border-bottom: 1px solid ${Colors.G600};
`;

export const StoryNameRow = styled.div`
  ${flexRow}
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
`;

export const StoryInfoRow = styled.div`
  ${flexRow}
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  font-size: 14px;
  line-height: 17px;
`;

export const StoryInfoLabel = styled.span`
  color: ${Colors.G300};
`;

export const StoryUrlContainer = styled.div`
  padding-top: 24px;
`;

export const StoryUrlParagraph = styled.div`
  padding: 12px 0;
`;

export const StoryUrlRow = styled.div`
  ${flexRow}
  justify-content: space-between;
  align-items: center;
`;

/**
 * Options -- Right Column
 */
export const Options = styled(Section)`
  ${flexColumn}
  flex-basis: 100%;
  flex: 1;
  background-color: ${Colors.G700};
  border-radius: 0 ${borderRadius.px()} ${borderRadius.px()} 0;
`;

export const OptionsContainer = styled.div`
  margin-top: 16px
`;

export const OptionsSubtitle = styled.span`
  font-size: 12px;
  line-height: 17px;
  text-transform: uppercase;
  color: ${Colors.G300};
  font-weight: 500;
`;

export const VisibilityContainer = styled(OptionsContainer)``;
export const EndingContainer = styled(OptionsContainer)``;

export const SettingsActions = styled.div`
  ${flexRow}
  width: 100%;
  padding: 12px 0 30px;
  justify-content: space-between;
`;

export const VisibilityOption = styled.div<{checked: boolean}>`
  ${flexRow}
  justify-content: space-between;
  margin-top: 16px;
  cursor: pointer;
  transition: opacity 0.3s;
  ${({ checked }): string => checked ? 'opacity: 1;' : 'opacity: .35;'}
`;

export const VisibilityLabels = styled.div`
  ${flexColumn}
  max-width: 280px;
  flex: 1;
`;

export const EndingFieldContainer = styled.div`
  ${flexRow}
  justify-content: space-between;
  margin-top: 12px;
`;

export const EndingLabelsContainer = styled.div`
  font-weight: 500;
`;

export const EndingLabel = styled.span`
  display: block;
  font-size: 14px;
  line-height: 17px;
`;

export const EndingCaption = styled.span`
  display: block;
  font-size: 12px;
  line-height: 17px;
  color: ${Colors.G300};
  cursor: pointer;

  &:hover {
    color: ${Colors.G100};
  }
`;

export const EndingPreviewImage = styled.img`
  width: 100%;
`;